import PageHead from "../../Head";
import Context from "@/context/Context";
import Footer from "@/my_components/Footer/Footer";
import HeaderContainer from "@/my_components/Header/HeaderContainer";
import BookingVerify from "@/my_components/_EventDetails/sections/BookingVerify";


const BookingVerifyPage = () => {

  return (
      <Context>
        <PageHead title="Verify an Event Booking | SmartTech Academy" />
        <HeaderContainer headerSticky="rbt-sticky" headerType="" topBarToggle="off" />

        <BookingVerify />

        <Footer bg="dark" />
      </Context>
  );
};

export default BookingVerifyPage;
